import { isTourV2Item } from 'lib/checkout/checkoutUtils'

export function isIncludedTourBundleHotel(item: App.Checkout.LEHotelItem, items: Array<App.Checkout.AnyItem>): boolean {
  return !!item.tourBundleId && !!item.bundledItemIds?.some(id => items.some(tour =>
    isTourV2Item(tour) && tour.itemId === id && tour.ltleBundleId === item.tourBundleId,
  ))
}

export function includedTourBundleHotelTotals(totals: App.Checkout.ItemViewTotals | undefined): App.Checkout.ItemViewTotals | undefined {
  if (!totals) return undefined
  return {
    price: 0,
    memberPrice: 0,
    value: 0,
    memberValue: 0,
    surcharge: 0,
    extraGuestSurcharge: 0,
    taxesAndFees: 0,
    isAvailable: totals.isAvailable,
  }
}
